export const UserDetailsPage = () => {
  return <h2>userdetails</h2>;
};
